"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PUSH_NOTIFY_FLAGS = exports.PUSH_DEVICE_TYPE = exports.PUSH_NOTIFY_BIT = void 0;
exports.buildPushNotifyBitmask = buildPushNotifyBitmask;
exports.parsePushNotifyBitmask = parsePushNotifyBitmask;
/** Битовая маска `ai` — как Android `AbstractC0123b1` / `MainActivity.e()`. */
exports.PUSH_NOTIFY_BIT = {
    QMS: 1,
    QMS_SYSTEM: 2,
    FAVORITES: 4,
    FAVORITES_IMPORTANT: 8,
    MENTIONS: 16,
};
/** `ai` type: 0 = Google FCM, 1 = Huawei HMS. */
exports.PUSH_DEVICE_TYPE = {
    GOOGLE: 0,
    HUAWEI: 1,
};
/** Значения по умолчанию в Android-клиенте. */
exports.DEFAULT_PUSH_NOTIFY_FLAGS = {
    qms: true,
    qmsSystem: true,
    favorites: true,
    favoritesImportant: false,
    mentions: true,
};
function buildPushNotifyBitmask(flags) {
    let mask = 0;
    if (flags.qms)
        mask |= exports.PUSH_NOTIFY_BIT.QMS;
    if (flags.qmsSystem)
        mask |= exports.PUSH_NOTIFY_BIT.QMS_SYSTEM;
    if (flags.favorites)
        mask |= exports.PUSH_NOTIFY_BIT.FAVORITES;
    if (flags.favoritesImportant)
        mask |= exports.PUSH_NOTIFY_BIT.FAVORITES_IMPORTANT;
    if (flags.mentions)
        mask |= exports.PUSH_NOTIFY_BIT.MENTIONS;
    return mask;
}
function parsePushNotifyBitmask(bitmask) {
    return {
        qms: (bitmask & exports.PUSH_NOTIFY_BIT.QMS) !== 0,
        qmsSystem: (bitmask & exports.PUSH_NOTIFY_BIT.QMS_SYSTEM) !== 0,
        favorites: (bitmask & exports.PUSH_NOTIFY_BIT.FAVORITES) !== 0,
        favoritesImportant: (bitmask & exports.PUSH_NOTIFY_BIT.FAVORITES_IMPORTANT) !== 0,
        mentions: (bitmask & exports.PUSH_NOTIFY_BIT.MENTIONS) !== 0,
    };
}
